import { chatgenieAPI } from '../../../services/chatgenieAPI';
import { ticketsTypes } from '../../types';

export const fetchTicketsByPage = ({ page, query }) =>
  chatgenieAPI.instance.get(`/tickets/info?page=${page || 1}&${query}&per_page=30`);

export const updateThreadMeta = payload => dispatch => {
  dispatch({
    type: ticketsTypes.UPDATE_THREAD_META,
    payload
  });
};

export const setThreadMeta = payload => dispatch => {
  dispatch({
    type: ticketsTypes.SET_THREAD_META,
    payload
  });
};

export const setTicketsWithDraft = payload => dispatch => {
  dispatch({
    type: ticketsTypes.SET_TICKETS_WITH_DRAFT,
    payload
  });
};

export const setThreadsWithActiveTimer = payload => dispatch => {
  dispatch({
    type: ticketsTypes.SET_THREADS_WITH_ACTIVE_TIMER,
    payload
  });
};

export const setLiveThreads = payload => dispatch => {
  dispatch({
    type: ticketsTypes.SET_LIVE_THREADS,
    payload
  });
};
